
import axios from 'axios';

// app config
import AppConfig from 'Constants/AppConfig';
import AuthHeader from 'Constants/AuthHeader';

import { NotificationManager } from 'react-notifications';
import {
   ALL_SSTEAMS,
   ADD_SSTEAM,
   SSTEAM_ACTION,
   EDIT_SSTEAM,
   STATUS_SSTEAM,
   DELETE_SSTEAM
} from 'Actions/types';

/**
 * SS Team Actions
 */
export const allSSTeam = () =>{
    
    
    return (dispatch) => { 
        dispatch({ type: SSTEAM_ACTION });
        return axios.get(AppConfig.apiurl+'/api/getssteam', { headers: AuthHeader.header })         
        .then(response => {             
            const allroles=response.data.data;
            dispatch({ type: ALL_SSTEAMS, payload: allroles });
        });
    }
    

}

export const addSSTeam = (teamval) => async (dispatch) => {
    
    var payload={
        "name":teamval.target.name.value,
        "designation":teamval.target.designation.value,
        "email":teamval.target.email.value,
        "mobile":teamval.target.mobile.value
     }
     dispatch({ type: SSTEAM_ACTION });
    return axios.post(AppConfig.apiurl+'/api/addssteam', payload, { headers: AuthHeader.header })
     .then( response => {       
         if(response.status==200){ 
            var resdata=response.data;
            if(resdata.status===1){
               allSSTeam()(dispatch);
               NotificationManager.success(resdata.message);               
               dispatch({ type: ADD_SSTEAM });
            }else{
               NotificationManager.error(resdata.message); 
            }
         }else{
            NotificationManager.error('Team not added');
         }            
         return Promise.resolve(resdata);
     })
     .catch( error => { 
       NotificationManager.error(error);
     });
}

export const editSSTeam = (teamval,id) => async (dispatch) => {
    
    var payload={
        "id":id,
        "name":teamval.target.name.value,
        "designation":teamval.target.designation.value,
        "email":teamval.target.email.value,
        "mobile":teamval.target.mobile.value
     }
     dispatch({ type: SSTEAM_ACTION });
    axios.post(AppConfig.apiurl+'/api/editssteam', payload, { headers: AuthHeader.header })
     .then( response => {       
         if(response.status==200){ 
            var resdata=response.data;
            if(resdata.status===1){
               allSSTeam()(dispatch);
               NotificationManager.success(resdata.message);               
               dispatch({ type: EDIT_SSTEAM });
            }else{
               NotificationManager.error(resdata.message); 
            }
         }            
         
     })
     .catch( error => { 
       NotificationManager.error(error);
     });
}

export const statusSSTeam = (id,status) => async (dispatch) => {
    
    var payload={
        "id":id,
        "status":status
     }
     dispatch({ type: SSTEAM_ACTION });
    axios.post(AppConfig.apiurl+'/api/statusssteam', payload, { headers: AuthHeader.header })
     .then( response => {       
         if(response.status==200){ 
            var resdata=response.data;
            if(resdata.status===1){
               allSSTeam()(dispatch);
               NotificationManager.success(resdata.message);               
               dispatch({ type: STATUS_SSTEAM });
            }else{
               NotificationManager.error(resdata.message); 
            }
         }            
         
     })
     .catch( error => { 
       NotificationManager.error(error);
     });
}

export const deleteSSTeam = (id) => async (dispatch) => {
    
    var payload={
        "id":id
     }
     dispatch({ type: SSTEAM_ACTION });
    axios.post(AppConfig.apiurl+'/api/deletessteam', payload, { headers: AuthHeader.header })
     .then( response => {       
         if(response.status==200){ 
            var resdata=response.data;
            if(resdata.status===1){
               allSSTeam()(dispatch);
               NotificationManager.success(resdata.message);               
               dispatch({ type: DELETE_SSTEAM });
            }else{
               NotificationManager.error(resdata.message); 
            }
         }            
         
     })
     .catch( error => { 
       NotificationManager.error(error);
     });
}

